<template>
    <DashboardLayout>
        <div class="home">
            <section class="summary">
                <div class="d-flex flex-column align-items-start">
                    <router-link :to="{ name: 'ViewWarrants' }"
                        class="btn btn-lg btn-outline-success register-btn d-flex justify-content-center align-items-center text-decoration-none">
                        <span class="material-symbols-outlined me-1 align-items-center">
                            article
                        </span>
                        Generated Warrants
                    </router-link>
                </div>

                <div class="d-flex flex-column align-items-end">
                    <router-link :to="{ name: 'ViewGeneratePVWithoutWarrant' }"
                        class="btn btn-lg btn-outline-success d-flex justify-content-end align-items-center text-decoration-none">
                        <span class="material-symbols-outlined me-1 align-items-center">
                            receipt_long
                        </span>
                        New PV Without Warrant
                    </router-link>
                </div>
            </section>

            <!-- Quick Actions -->
            <section class="summary-actions d-flex flex-column" :key="menuVersion">
                <div class="action-container-row d-flex flex-wrap w-100">
                    <div class="single-action-wrapper">
                        <router-link :to="{ name: 'ViewPaymentVouchers', query: { status: 'pending' } }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined pending">schedule</span>
                                </div>
                                <h2 class="fw-semibold mb-2">{{ numberOfPendingPVs }}</h2>
                                <h3 class="fw-normal">Pending Approval</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper">
                        <router-link :to="{ name: 'ViewPaymentVouchers', query: { status: 'completed' } }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined">check_circle</span>
                                </div>
                                <h2 class="fw-semibold mb-2">{{ numberOfCompletedPVs }}</h2>
                                <h3 class="fw-normal">Completed</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper">
                        <router-link :to="{ name: 'ViewPaymentVouchers', query: { status: 'returned' } }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined Returned">cancel</span>
                                </div>
                                <h2 class="fw-semibold mb-2">{{ numberOfReturnedPVs }}</h2>
                                <h3 class="fw-normal">Returned</h3>
                            </div>
                        </router-link>
                    </div>
                </div>
            </section>

            <!-- Recently PaymentVouchers -->
            <section class="summary-table d-flex flex-column">
                <h2 class="mb-4">Recent Payment Vouchers</h2>
                <div class="table-wrapper">

                    <div v-if="loadingPvs" class="loading-state text-center py-5 border rounded rounded-table">
                        <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                        <p class="mt-2 mb-0 text-muted">Loading payment vouchers...</p>
                    </div>

                    <div v-else class="table-container border rounded rounded-table">
                        <table class="responsive-table">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">PV No</th>
                                    <th scope="col">Payee</th>
                                    <th scope="col" class="text-end">Amount</th>
                                    <th scope="col">Date Initiated</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(pv, index) in recentCompletedPvs.slice(0, 5)" :key="index"
                                    :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                                    <td scope="row" class="serial-no text-center">{{ index + 1 }}</td>
                                    <td scope="row" class="primary-col text-start">
                                        <router-link
                                            :to="{ name: 'ViewPaymentVoucher', params: { id: pv.id }, query: { mdaid: pv.mdaId, year: pv.year } }"
                                            class="view-link text-decoration-underline">
                                            {{ pv.pvNumber || 'N/A' }}
                                        </router-link>
                                    </td>
                                    <td class="secondary-col text-start">{{ pv.payee }}</td>
                                    <td class="secondary-col text-end">{{ formatCurrency(pv.amountCompleted || 0) }}
                                    </td>
                                    <td class="secondary-col pv-date">
                                        <span v-if="pv.importedPaymentVoucherInd === 1">
                                            N/A
                                        </span>
                                        <span v-else>{{ formatDate(pv.pvInitiatedDate) }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span v-if="pv.pvCompletedInd === 1">Completed</span>
                                        <span v-else-if="pv.pvReturnedInd === 1">Returned</span>
                                        <span v-else>Pending</span>
                                    </td>
                                    <!-- <td class="text-center action">
                                    <router-link
                                        :to="{ name: 'ViewPaymentVoucher', params: { id: pv.id }, query: { mdaid: pv.mdaId, year: pv.year } }"
                                        class="view-link text-decoration-none">
                                        View
                                    </router-link>
                                </td> -->
                                </tr>
                                <tr v-if="recentCompletedPvs.length !== 0">
                                    <td colspan="6" class="text-center action">
                                        <router-link :to="{ name: 'ViewPaymentVouchers' }"
                                            class="view-link text-decoration-none mt-2">
                                            View More
                                        </router-link>
                                    </td>
                                </tr>
                                <tr v-if="recentCompletedPvs.length === 0">
                                    <td colspan="6" class="text-center">No Payment Vouchers to display.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </div>
    </DashboardLayout>
</template>

<script setup>
import { ref, onMounted, defineOptions, watch, computed } from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie';
import DashboardLayout from './layout/DashboardLayout.vue'
import '@/assets/css/table.css'
import Swal from 'sweetalert2';
import { useUserStore } from '@/stores/user'


const pvs = ref([])
const loadingPvs = ref(true)
const root_api_url = process.env.VUE_APP_API_ROOT_URL

const userStore = useUserStore()

defineOptions({
    name: 'DashboardHomePage',
})

// const allRoles = [
//     'dirOfPayment',
//     'dirOfTreasury',
//     'dirCAD',
//     'acctGeneral',
//     'pvInitiator',
// ];

// const hasAccess = (required) => {
//     const profileRoles = userStore.profile?.role || {};

//     const userHasRole = (role) => !!profileRoles[role];

//     if (!required || required.length === 0) return true;

//     if (required.includes('')) {
//         const otherRoles = required.filter(role => role !== '');

//         if (otherRoles.some(role => userHasRole(role))) return true;

//         const isFreeUser = Object.keys(profileRoles).every(r => !allRoles.includes(r) || profileRoles[r] === false);
//         if (isFreeUser) return true;

//         return false;
//     }

//     return required.some(role => userHasRole(role));
// }

const onBoarding = async () => {
    const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`

    const { value: formValues } = await Swal.fire({
        title: 'Welcome to OGPABS!',
        html: `
        <p>Before you continue, please change your password:</p>
        <br />
        <div class="form-outer">
            <div class="form-group">
                <label for="oldPassword">Old Password</label><br />
                <input type="password" id="oldPassword" class="input" placeholder="********" autocomplete="off" required>
                <span class="toggle-password" data-target="oldPassword">
                    <i class="far fa-eye"></i>
                </span>
            </div>

            <div class="form-group">
                <label for="newPassword">New Password</label><br />
                <input type="password" id="newPassword" class="input" placeholder="********" autocomplete="new-password" title="Password must contain at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character" required>

                <span class="toggle-password" data-target="newPassword">
                    <i class="far fa-eye"></i>
                </span>
            </div>

            <div class="form-group">
                <label for="confirmPassword">Confirm Password</label><br />
                <input type="password" id="confirmPassword" class="input" placeholder="********" autocomplete="new-password" title="Re-enter your new password" required>
                <span class="toggle-password" data-target="confirmPassword">
                    <i class="far fa-eye"></i>
                </span>
            </div>
        </div>
        `,
        icon: 'warning',
        confirmButtonText: 'Submit',
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: true,
        customClass: {
            popup: 'ogpabs-swal',
            htmlContainer: 'ogpabs-swal-html'
        },
        didOpen: (el) => {
            el.querySelectorAll('.toggle-password').forEach(btn => {
                btn.addEventListener('click', () => {
                    const targetId = btn.getAttribute('data-target');
                    const input = el.querySelector(`#${targetId}`);
                    const icon = btn.querySelector('i');

                    const isHidden = input.type === 'password';
                    input.type = isHidden ? 'text' : 'password';

                    icon.classList.toggle('fa-eye');
                    icon.classList.toggle('fa-eye-slash');
                });
            });
        },
        preConfirm: async () => {
            const password = document.getElementById('oldPassword').value
            const newPassword = document.getElementById('newPassword').value
            const confirmPassword = document.getElementById('confirmPassword').value

            const firstName = userStore.profile.firstName
            const lastName = userStore.profile.lastName
            const email = userStore.profile.userName

            if (!firstName || !lastName || !email) {
                Swal.showValidationMessage('User profile not loaded yet, please try again')
                return false
            }

            if (newPassword !== confirmPassword) {
                Swal.showValidationMessage('Passwords do not match')
                return false
            }

            try {
                const token = Cookies.get('auth_token')
                const response = await axios.post(`${root_api_url}/auth/reset-password`, {
                    firstName,
                    lastName,
                    email,
                    password,
                    newPassword,
                    confirmPassword
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                })
                if (response.status === 200) {
                    return true
                }
            } catch (error) {
                if (error?.response?.status === 417) {
                    Swal.showValidationMessage(error?.response?.data?.errorMessage || error?.response?.data?.error)
                } else if (error?.response?.status === 503) {
                    Swal.showValidationMessage(error.response?.data?.error)
                } else {
                    Swal.showValidationMessage('Failed to change password')
                }
                return false
            }
        }
    })

    if (formValues) {
        await Swal.fire({
            html: `${iconHtmlSuccess}<p>Password changed successfully!</p>`,
            showConfirmButton: true
        })
    }
}

const numberOfPendingPVs = ref(0)
const numberOfCompletedPVs = ref(0)
const numberOfReturnedPVs = ref(0)

const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
        timeZone: 'UTC',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    })
}

function formatCurrency(val) {
    if (val === '' || val === null) return '';
    const num = parseFloat(val).toFixed(2);
    return '₦' + Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// const fetchPaymentVouchersCount = async () => {
//     const token = Cookies.get('auth_token');
//     try {
//         await axios.get(`${root_api_url}/pv/pv`, {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//                 'Content-Type': 'application/json',
//             },
//         });
//         numberOfPendingPaymentVouchers.value = pvs.value.length - (pvs.value.filter(pv => pv.warrantCompletedInd === 1 || pv.pvReturnedInd === 1 || pv.importedPaymentVoucherInd === 1).length);
//     } catch (error) {
//         console.error('Failed to fetch pv count:', error);
//         numberOfPendingPaymentVouchers.value = 0;
//     }
// }
const recentCompletedPvs = computed(() => {
    return pvs.value
        .filter(pv => pv.pvCompletedInd === 1)
        .sort((a, b) => new Date(b.pvInitiatedDate) - new Date(a.pvInitiatedDate))
        .slice(0, 5)
})

const fetchPaymentVouchers = async () => {
    const token = Cookies.get('auth_token');
    loadingPvs.value = true
    try {
        const response = await axios.get(`${root_api_url}/payment/vouchers/all`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        pvs.value = response.data.map(pv => ({
            id: pv.id,
            pvNumber: pv.pvNumber ?? '',
            payee: pv.payee ?? '',
            originatingMda: pv.mdaName ?? '',
            amountCompleted: pv.netAmount ?? pv.grossAmount ?? 0,
            pvInitiatedDate: pv.pvInitDate ?? pv.createdDate ?? '',
            pvCompletedInd: pv.completedPVInd ?? (pv.completed ? 1 : 0),
            pvReturnedInd: pv.returnedPVInd ?? 0,
            pvPendingInd: pv.pendingPVInd ?? 0,
            mdaId: pv.mdaId ?? null,
            year: pv.pvYear ?? null,
        }))

        numberOfPendingPVs.value = pvs.value.filter(pv => pv.pvPendingInd).length
        numberOfCompletedPVs.value = pvs.value.filter(pv => pv.pvCompletedInd).length
        numberOfReturnedPVs.value = pvs.value.filter(pv => pv.pvReturnedInd).length
    } catch (error) {
        console.error('Failed to fetch pvs:', error)
        pvs.value = []
        numberOfPendingPVs.value = 0
        numberOfCompletedPVs.value = 0
        numberOfReturnedPVs.value = 0
    } finally {
        loadingPvs.value = false
    }
}

watch(
    () => userStore.profile?.deltaPasswordInd, (val) => {
        if (val == 1) {
            onBoarding()
        }
    }, { immediate: true }
)

const profileRoles = computed(() => userStore.profile?.role || {})
const menuVersion = ref(0)

watch(
    profileRoles,
    (newRoles, oldRoles) => {
        if (!oldRoles) {
            return
        }
        if (JSON.stringify(newRoles) !== JSON.stringify(oldRoles)) {
            menuVersion.value++
        }
    },
    { deep: true, immediate: true }
)

onMounted(async () => {
    if (userStore.profile?.deltaPasswordInd == 1) {
        await onBoarding();
    }
    await fetchPaymentVouchers();
    // await fetchPaymentVouchersCount();
    document.title = "Dashboard";
});
</script>

<style scoped>
.btn {
    color: var(--btn-alt) !important;
    border-color: var(--btn-alt) !important;
}

.btn:hover {
    color: #fff !important;
    background-color: var(--btn-alt-hover) !important;
    border-color: var(--btn-alt-hover) !important;
}

.text-center.action .btn {
    background-color: var(--btn-primary);
    border: none !important;
    border-radius: 0px !important;
}

.amount {
    padding-right: 3rem !important;
}

/* Summary cards - ensure proper stacking on mobile */
.summary {
    display: flex;
    gap: 1rem;
    margin-bottom: 2rem;
}

.summary>div {
    flex: 1;
    padding: 0.5rem;
}

/* Mobile responsive - stack summary cards vertically */
@media (max-width: 768px) {
    .summary {
        flex-direction: column;
    }
}

/* Quick Actions - responsive grid */
.action-container-row {
    gap: 1rem;
}

.single-action-wrapper {
    flex: 0 0 auto;
    flex-grow: 1;
    width: calc(25% - 0.75rem);
    min-width: 150px;
}

/* Mobile - 2 columns */
@media (max-width: 768px) {
    .single-action-wrapper {
        width: calc(50% - 0.5rem);
    }
}

/* Small mobile - 1 column */
@media (max-width: 480px) {
    .single-action-wrapper {
        width: 100%;
    }
}

.single-action-card {
    background: var(--card);
    padding: 1rem;
    border-radius: 8px;
    text-align: center;
    transition: transform 0.2s;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.single-action-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.action-icon {
    margin-bottom: 1rem;
}

.action-icon .material-symbols-outlined.pending {
    font-size: 2.5rem;
    color: #FFC107;
}

.action-icon .material-symbols-outlined {
    font-size: 2.5rem;
    color: #28A745;
}

.action-icon .material-symbols-outlined.Returned {
    font-size: 2.5rem;
    color: #DC3545;
}

.single-action-card h3 {
    font-size: 0.95rem;
    margin: 0;
    color: var(--color);
}

.create-pv-btn {
    background-color: var(--btn-primary) !important;
    margin: 10px;
    height: 50px;
    font-weight: 600;
    color: white !important;
    border: none !important;
    border-radius: 0px !important;
    padding: 10px;
}

.create-pv-btn span {
    margin-right: 5px;
    font-weight: 600;
}

.create-pv-btn:hover {
    background-color: var(--btn-alt) !important;
}

.material-symbols-outlined {
    font-size: 1.25rem;
}

:global(.ogpabs-swal .form-outer) {
    text-align: center;
    width: 410px;
    margin: 0 auto;
}

:global(.ogpabs-swal .form-group) {
    position: relative;
    text-align: left;
    margin: 10px auto;
    font-size: 16px;
}

:global(.ogpabs-swal .form-group label) {
    text-align: left !important;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
}

:global(.ogpabs-swal .form-group .input) {
    width: 100%;
    color: #000;
    border: 1px solid #C9C9C9;
    border-radius: 10px;
    padding: 6px 10px;
    box-sizing: border-box;
}

:global(.ogpabs-swal .form-group .input:focus-visible) {
    outline: none;
    border-color: #7aa7ff;
}

:global(.ogpabs-swal .toggle-password) {
    position: absolute;
    right: 10px;
    top: 32px;
    cursor: pointer;
    color: #888;
}

:global(.ogpabs-swal .toggle-password:hover) {
    color: #111;
}
</style>
